export const APP_CONFIG = {
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  SUPPORTED_FILE_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'text/markdown',
    'text/csv',
    'application/json',
    'text/xml',
    'text/html',
  ],
  MAX_UPLOAD_FILES: 10,
  DEFAULT_PAGINATION_LIMIT: 10,
}
export const AI_MODELS = {
  openai: [
    { value: 'gpt-4-turbo', label: 'GPT-4 Turbo (Recommended)' },
    { value: 'gpt-4', label: 'GPT-4' },
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
  ],
  internal: [
    { value: 'llama-3', label: 'Llama 3 (Internal)' },
    { value: 'deepseek', label: 'DeepSeek (Internal)' },
  ],
}
export const EMBEDDING_MODELS = [
  { value: 'ada-002', label: 'OpenAI Ada-002 (Recommended)' },
  { value: 'bge-large', label: 'BGE-Large' },
  { value: 'instructor-xl', label: 'InstructorXL' },
  { value: 'custom', label: 'Custom Internal Embeddings' },
]
export const RESPONSE_LENGTHS = [
  { value: 'short', label: 'Short (< 150 words)' },
  { value: 'medium', label: 'Medium (150-300 words)' },
  { value: 'long', label: 'Long (> 300 words)' },
]
export const TONES = [
  { value: 'formal', label: 'Formal' },
  { value: 'friendly', label: 'Friendly' },
  { value: 'professional', label: 'Professional' },
  { value: 'neutral', label: 'Neutral' },
  { value: 'casual', label: 'Casual' },
]
export const STYLES = [
  { value: 'paragraph', label: 'Paragraph' },
  { value: 'bullet-points', label: 'Bullet Points' },
  { value: 'numbered-list', label: 'Numbered List' },
  { value: 'conversational', label: 'Conversational' },
]
export const OUTPUT_TYPES = [
  { value: 'Summary', label: 'Summary' },
  { value: 'Analysis', label: 'Analysis' },
  { value: 'Step-by-Step', label: 'Step-by-Step' },
  { value: 'Custom', label: 'Custom' },
]
export const ERROR_MESSAGES = {
  GENERIC: 'An unexpected error occurred. Please try again.',
  NETWORK: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION: 'Please check your input and try again.',
  FILE_SIZE: 'File size exceeds the maximum limit.',
  FILE_TYPE: 'File type is not supported.',
  UPLOAD_LIMIT: 'Maximum number of files exceeded.',
}
export const COMPANY_CONFIG = {
  name: "Sprinklenet",
  domain: "sprinklenetlabs.com",
  supportEmail: "support@sprinklenetlabs.com",
  adminEmail: "admin@sprinklenetlabs.com",
  website: "https://sprinklenetlabs.com"
}